import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalFormatter',
    standalone: false
})
export class DecimalFormatterPipe implements PipeTransform {

  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const parsedValue = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(parsedValue)) {
      return String(value);
    }

    return parsedValue
      .toLocaleString('ru-RU')
      .replace(/\u00A0/g, ' ')
      .replace(/\u202F/g, ' ');
  }

}
